import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper, useMediaQuery, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import TitleBar from '../TitleBar';
import { jobworkMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { selectEmployees } from '../Selectors/Master/ItemSelectors';
import Dropdown from '../FieldsComponents/Dropdown';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { insertAdvanceAmt } from '../../Store/PHPSlice/Jobwork/jobworkApi';
import AmountTypeReg from '../JobworkTbl/AmountTbl/AmountTypeReg';


const AdvancePayment = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        empId: '',
        paytype: '',
        advAmt: '',
        userId: userdata?.userId
    });
    const dispatch = useDispatch();
    const emplist = useSelector(selectEmployees);

    useEffect(() => {
        dispatch(fetchEmployeeData());
    }, []);

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' }
    ];

    const fields2 = [
        { label: 'Amount', name: 'advAmt' }
    ];

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value, name } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    const isDesktop = useMediaQuery('(min-width:768px)');

    const paytype = [
        { label: 'Advance', value: 'Advance' },
        { label: 'Baki', value: 'Baki' },
        { label: 'Machinary', value: 'Machinary' },
        { label: 'Purchase', value: 'Purchase' },
        { label: 'PF', value: 'PF' },
        { label: 'ESI', value: 'ESI' }
    ];

    const dropdownlistfirst = [

        {
            label: 'Payment Type',
            id: 'paytype',
            options: Array.isArray(paytype) ? paytype : [],
            value: formData.paytype,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'paytype', value: newValue ? newValue.value : '' } }, 'paytype'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Employee',
            id: 'empId',
            options: Array.isArray(emplist?.data) ? emplist?.data : [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleSubmit = (e) => {
        e.preventDefault();

        // const finaldata = postObj(formData, jobwork);
        // console.log(jobworkData);
        dispatch(insertAdvanceAmt(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Material Added");
                alert("Record Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <TitleBar data={jobworkMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Advance/Baki/Machinary/Purchase/PF/ESI- Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1}>
                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {fields2.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>

                <AmountTypeReg />
            </div>
        </>
    );
}

export default AdvancePayment;
